<template>
	<component
		:is="content.href ? 'a' : 'button'"
		:href="content.href ? content.href : '#'"
		class="itv-primary-button"
		:class="getClasses()"
		@click="$emit('clickEvent')"
		type="button"
	>
		<slot name="icon-left"></slot>
		<span class="itv-primary-button__text" v-html="content.text"></span>
		<slot name="icon-right"></slot>
	</component>
</template>

<script>
export default {
	name: 'SocialButton',
	props: {
		content: {
			type: Object,
			default: () => {},
			// btnColorType: ['green', 'black', 'gray', 'transparent', 'noBorder']
		},
	},
	methods: {
		getClasses() {
			let classStr = this.content.btnColorType

			if (this.content.href && this.content.href.includes('#')) {
				classStr = `${this.content.btnColorType} js--anchor`
			}

			return classStr
		},
	},
}
</script>
